import React from "react";
import { Link } from "react-router-dom";

const FeedbackSuccessModal = ({ onModalClose }) => {
  return (
    <div className="request_modal">
      <div
        className="modal fade"
        id="submit_feedback"
        data-bs-backdrop="static"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-sm"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-body p-4">
              <div className="request_alert_icon d-flex align-items-center justify-content-center">
                <img src="images/submit-tick.svg" alt="" />
              </div>
              <div className="request_info text-center">
                <h3 className="text-primary fs-lg text-uppercase mb-4">
                  Feedback Submited
                </h3>
                <div className="request_btns d-flex gap-2 justify-content-center">
                  <Link
                    to="#"
                    data-bs-dismiss="modal"
                    className="btn primary-btn w-50"
                  >
                    Done
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeedbackSuccessModal;
